var angular = require('angular');
var _module = angular.module('benoit');
var _ = require('lodash');
var simpleCypher = require('../../../libs/simple-cypher');

require('../price-slider');
require('../../services/search-filter-params');
require('../../services/search-filter');
require('../../services/error-modal');
require('../../services/fullscreen-loading');
require('../../services/analytics');
require('../../services/login-or-register-modal');
require('../../services/user');
require('../../services/add-buyer-agent-modal');

_module.controller('InviteSearchFilterCtrl', [
    '$log',
    '$scope',
    'searchFilterParams',
    'SearchFilter',
    '$state',
    '$stateParams',
    '$errorModal',
    '$fsloading',
    '$analytics',
    'UserLoggedOut',
    '$addBuyerAgentModal',

    function InviteSearchFilterCtrl($log, $scope, searchFilterParams, SearchFilter, $state, $stateParams, $errorModal, $fsloading, $analytics, UserLoggedOut, $addBuyerAgentModal) {
        $log.debug('InviteSearchFilterCtrl', this);

        var searchFilterParamOptions = searchFilterParams.get();
        var userId = simpleCypher.decodeString($stateParams.encodedUserId);
        var user = new UserLoggedOut(userId);
        var vm = this;
        vm.model = {
            data: {
                location: undefined,
                price: 1000000,
                bedrooms: undefined,
                bathrooms: undefined,
                hometype: undefined
            },
            options: {
                bedrooms: _.chain(searchFilterParamOptions).find({ id: 'bedrooms' }).get('values', []).map(function (opt) { return { label: opt.title, value: opt.id }; }).value(),
                bathrooms: _.chain(searchFilterParamOptions).find({ id: 'bathrooms' }).get('values', []).map(function (opt) { return { label: opt.title, value: opt.id }; }).value(),
                hometype: _.chain(searchFilterParamOptions).find({ id: 'hometype' }).get('values', []).map(function (opt) { return { label: opt.title, value: opt.id }; }).value()
            },
            user: user
        };
        vm.events = {
            onFormSubmit: saveSearchFilter
        };

        // Functions
        function saveSearchFilter($form) {
            $log.debug('Form Submitted', $form.$valid, $form);
            $log.debug('User ID', userId);
            $log.debug('vm.model.data', vm.model.data);

            if($form.$valid) {
                var searchFilter = new SearchFilter({
                    ownerId: userId,
                    name: ['My', vm.model.data.location, 'Homes'].join(' '),
                    search_term: vm.model.data.location
                });

                if(vm.model.data.price) {
                    searchFilter.addFilter('price', vm.model.data.price);
                }

                if(vm.model.data.bedrooms) {
                    searchFilter.addFilter('bedrooms', vm.model.data.bedrooms);
                }

                if(vm.model.data.bathrooms) {
                    searchFilter.addFilter('bathrooms', vm.model.data.bathrooms);
                }

                if(vm.model.data.hometype) {
                    searchFilter.addFilter('hometype', vm.model.data.hometype);
                }

                $fsloading.show();
                searchFilter.save()
                .finally(function () {
                    $fsloading.hide();
                })
                .then(function (response) {
                    var buyerAgentVerified = _.get(user, 'buyer_agent.verified');

                    $analytics.eventTrack('Nest Mini-Pref Page Submit', {
                        'distinct_id': userId,
                        'User Id': userId
                    });

                    if(!buyerAgentVerified && !user.errorFetchingUser) {
                        return showAddBuyerModal(userId);
                    } else {
                        return;
                    }
                })
                .then(function () {
                    $state.go('.success');
                })
                .catch(function (err) {
                    $log.error(err);
                    $errorModal();
                });
            }
        }

        function showAddBuyerModal(userId) {
            var data = {
                id: userId,
                analyticsEventNameSubmit: 'Nest Buyer Agent Info Submit',
                analyticsEventDataSubmit: {
                    Source: 'Mini Prefs'
                }
            };

            return $addBuyerAgentModal(data).result
            // Temp Commented out by LC. Will add back in when the email is complete
            // .then(function onResponse(response) {
            //     user.sendBuyerAgentUpdatedEmail()
            //     .then(function () {
            //         var affiliate = user.affiliate || {};

            //         $analytics.eventTrack('Nest Buyers Agent Verification Email Sent', {
            //             'distinct_id': userId,
            //             'Consumer Name': user.name,
            //             'Consumer Email': user.email,
            //             'Consumer Phone': user.phone,
            //             'Affiliate Name': affiliate.name,
            //             'Affiliate Company': affiliate.company,
            //             'Affiliate Email': affiliate.email
            //         });
            //     });

            //     return response;
            // })
            .catch(function (err) {
                if(err) {
                    $log.error(err);
                } else {
                    $analytics.eventTrack('Nest Buyer Agent Info Skip', {
                        Source: 'Mini Prefs'
                    });
                }

                return;
            });
        }
    }
]);

_module.component('inviteSearchFilter', {
    controllerAs: 'vm',
    controller: 'InviteSearchFilterCtrl',
    template: require('./index.html')
});

_module.component('inviteSearchFilterSuccess', {
    controllerAs: 'vm',
    controller: [
        '$log',
        '$stateParams',
        '$loginOrRegisterModal',

        function ($log, $stateParams, $loginOrRegisterModal) {
            var vm = this;
            vm.model = {
                userId: simpleCypher.decodeString($stateParams.encodedUserId)
            };
            vm.services = {
                $loginOrRegisterModal: $loginOrRegisterModal
            };
        }
    ],
    template: require('./success.html')
});
